/**
 * stations-select
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

import getSelectedOptions from "../common/get-selected-options";

export default (dataUrl, settingOptions = {}) => sb => {
    let stationsSelect,
        alphaScroller,
        selectAllStations,
        deselectAllStations,
        settings;

    const scrollStationsToLetter = function scrollStationsToLetter(e) {
        e.preventDefault();

        if (e.target.nodeName !== "A") {
            return;
        }

        const letter = e.target.href.charAt(e.target.href.length - 1);
        const group = stationsSelect.query(`optgroup[label=${letter}]`);
        const singleOptionHeight = stationsSelect[0].scrollHeight / stationsSelect.query("*").length;

        stationsSelect.scrollTop(group[0].dataset.index * singleOptionHeight);
    };

    const selectOrDeselectAllStations = function selectOrDeselectAllStations(mustSelect) {
        for (let option of stationsSelect[0].getElementsByTagName('option')) {
            option.selected = mustSelect;
        }

        onStationsSelectionChange();
    };

    const onSelectAllStations = function onSelectAllStations(e) {
        e.preventDefault();
        if(stationsSelect[0].disabled !== true) {
            selectOrDeselectAllStations(true);
            jQuery(stationsSelect[0]).trigger('change');
        }
    };

    const onDeselectAllStations = function onDeselectAllStations(e) {
        e.preventDefault();
        selectOrDeselectAllStations(false);
    };

    const fetchStations = function fetchStations() {
        return sb.postApi(dataUrl, {
            historical: settings.historical ? 1 : 0
        }).then(stationGroups => {
            sb.notify({
                type: "stationsLoaded",
                data: Object.keys(stationGroups).reduce((acc, groupKey) => {
                    return acc.concat(stationGroups[groupKey]);
                }, [])
            });

            return stationGroups;
        });
    };

    const populateStationsSelect = function populateStationsSelect(stationGroups) {
        let index = 0;
        const options = Object.keys(stationGroups).map(letter => {

            const opts = stationGroups[letter].map(station => {
                let styleSelected = '',
                    value = station.id,
                    title = "";

                if (settings.selected.length > 0) {
                    styleSelected = settings.selected.indexOf(station.name.toLowerCase()) !== -1
                        ? 'selected="selected"'
                        : '';
                } else {
                    styleSelected = 'selected="selected"';
                }

                //noinspection JSUnresolvedVariable
                if (station.new_name) {
                    styleSelected = 'style="color:graytext;"';
                    value += "_" + station.name;
                    //noinspection JSUnresolvedVariable
                    title = ` title='"${station.new_name}" since ${station.update_date}'`;
                }

                return `<option ${styleSelected} value="${value}"${title}>${station.name}</option>`;
            });

            const optgroup = `<optgroup label="${letter}" data-index="${index}">`;
            // "1" counts every "optgroup letter" row
            index += 1 + opts.length;

            return optgroup + opts.join("\n") + "</optgroup>";
        }).join("\n");

        sb.append(stationsSelect, options);
        onStationsSelectionChange(); // We've added stations selected

        return stationGroups;
    };

    const populateAlphaScroller = function populateAlphaScroller(stationGroups) {
        const valid = Object.keys(stationGroups);

        /* 1) Fill an array with 27 nulls
         * 2) For each index in the array generate a letter from the char code
         *    (or # if the index is zero)
         * 3) If that letter is a key in stationGroups, generate a link for it,
         *    otherwise just return it verbatim.
         */
        const links = Array.apply(null, {length: 27}).map((_, i) => {
            let letter = i < 1 ? "#" : String.fromCharCode(i + 64);

            if (~valid.indexOf(letter)) {
                return `<a href="${letter}">${letter}</a>`;
            }

            return letter;
        }).join("\n");

        sb.append(alphaScroller, links);
    };

    const onStationsSelectionChange = function onStationsSelectionChange() {
        sb.notify({
            type: "stationsSelectionChanged",
            data: [].map.call(
                getSelectedOptions(stationsSelect[0]),
                option => option.value
            )
        });
    };

    return {
        init() {
            settings = (typeof settingOptions !== "object") ? {} : settingOptions;
            settings.selected = settingOptions.selected || '';
            settings.historical = (settingOptions.historical === undefined) ? true : settingOptions.historical;

            stationsSelect = sb.find("#station");
            alphaScroller = sb.find("#station_letters");
            selectAllStations = sb.find("#station_select_all");
            deselectAllStations = sb.find("#station_deselect_all");

            sb.addEvent(stationsSelect[0], "change", onStationsSelectionChange);
            sb.addEvent(alphaScroller, "click", scrollStationsToLetter);
            sb.addEvent(selectAllStations, "click", onSelectAllStations);
            sb.addEvent(deselectAllStations, "click", onDeselectAllStations);

            fetchStations().then(populateStationsSelect).then(
                populateAlphaScroller
            ).then(
                sb.listen({
                    streamsSelectionChanged: checked => {
                        if(checked.length) {
                            const status = (parseInt(checked[0]) !== 1)
                            selectOrDeselectAllStations(!status);
                            stationsSelect[0].disabled = status;
                        }
                    }
                })
            );
        },
        destroy() {
            sb.removeEvent(deselectAllStations, "click", onDeselectAllStations);
            sb.removeEvent(selectAllStations, "click", onSelectAllStations);
            sb.removeEvent(alphaScroller, "click", scrollStationsToLetter);
            sb.removeEvent(stationsSelect[0], "change", onStationsSelectionChange);

            deselectAllStations = null;
            selectAllStations = null;
            alphaScroller = null;
            stationsSelect = null;
        }
    }
};
